import React from 'react'
import './styles.scss'

export const Loader = ({ children }) => <span className="loader">{children}</span>
